module.exports = __webpack_public_path__ + "static/media/rober9.ac2f5877.jpg";